<template>
    <div>
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">CID Label</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="printcidlabel"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="print"
                    >Print</vs-button>
                </div>
            </div>
        </vx-card>
        <vx-card class="mt-4">
            <vx-input-group class="mb-6 mt-8">
                <template slot="prepend">
                    <div class="prepend-text bg-primary">
                        <span>Label</span>
                    </div>
                </template>
                <vs-input type="number" min="0" max="1000" v-model="totalprint" size="large" />
            </vx-input-group>
        </vx-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            totalprint: 0
        };
    },
    methods: {
        printcidlabel() {
            if (this.totalprint > 0) {
                this.isLoading = true;
                this.$http
                    .post("master/cidlabel/print_label", {
                        totalprint: this.totalprint
                    })
                    .then(response => {
                        var blob = new Blob([response.data], {
                            type: "application/pdf"
                        });
                        window.open(URL.createObjectURL(blob));
                    })
                    .catch(error => this.handleError(error))
                    .then(() => (this.isLoading = false));
            } else {
                this.$vs.notify({
                    color: "danger",
                    title: "Label Count less than 1",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "Please Insert Label count more than 1"
                });
            }
        }
    }
};
</script>